import { DataModel } from "common/models/utility-models/base-model";

export class CreditModel extends DataModel {
    yearSelected: any = '';
    type_id: any = '';
    batch_id: any = '';
    credits: any = '';
}